import { useLocation, useNavigate, useSearchParams, useParams } from "react-router-dom";
import StarPrivilegeTag from '../../../svgs/StarPrivilegeTag';
import PremiumPrivilegeTag from '../../../svgs/PremiumPrivilegeTag';
import KnowMoreButton from '../../../svgs/KnowMoreButton';

const iPhoneWidth = 430
export default function Page(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    const [searchParams, setSearchParams] = useSearchParams();
    const data = props.data


    return (
        <div className="relative h-full w-full flex flex-col items-center justify-start bg-[#999] p-[16px] gap-[16px]" style={{ overflowY: 'auto' }}>

            <div className="border-[4px] border-[#666] rounded-[16px]" style={{ width: iPhoneWidth, backgroundColor: "#F3F8FB" }}>





                <div className='relative w-full' style={{ borderTopRightRadius: 16, borderTopLeftRadius: 16, overflow: 'hidden' }}>
                    <img src={data?.hero || data.thumbnail} className='w-full' style={{ objectFit: 'cover', height: undefined, aspectRatio: (data.hero && data?.heroAspectRatio) ? data?.heroAspectRatio : 600 / 350 }} />
                </div>

                <div className='flex flex-col w-full pt-[16px]'>

                    {(data?.isStarPrivilege || data?.isPremiumPrivilege) &&
                        <div className="flex flex-row items-center ml-[16px] mb-[16px]" style={{ gap: 8 }}>
                            {data?.isStarPrivilege&&<StarPrivilegeTag />}
                            {data?.isPremiumPrivilege&&<PremiumPrivilegeTag />}
                        </div>
                    }

                    <div className='flex text-[18px] text-[#6E604C] font-[600] px-[16px]'>{data?.name || "-"}</div>
                    <div className='flex mt-[16px] flex-col w-full'>
                        {data?.content?.map((c, ci) =>
                            c.type === 'text' ? <div className='my-[8px] px-[16px]' key={ci} style={{ color: c?.isTitle ? '#6E604C' : "#473F3A", fontWeight: c?.isTitle ? 700 : 400, fontSize: c?.isTitle ? 18 : 12, whiteSpace: 'pre-line' }}>{c?.data || ''}</div>
                                : c.type === 'image' ? (
                                    c.redirect ?
                                        <div key={ci} className='w-full flex flex-row' style={{ justifyContent: c?.justifyContent || 'center', width: '100%' }}>
                                            <img src={c?.url} className='w-full my-[8px]' style={{ objectFit: 'contain', height: undefined, aspectRatio: c.aspectRatio || 1, paddingLeft: c?.isFullWidth ? 0 : 16, paddingRight: c?.isFullWidth ? 0 : 16, width: c.width || '100%' }} />
                                        </div>
                                        : <div key={ci} className="w-full flex flex-row" style={{ justifyContent: c?.justifyContent || 'center', width: '100%' }}>
                                            <img src={c?.url} className='w-full my-[8px]' style={{ objectFit: 'contain', height: undefined, aspectRatio: c.aspectRatio || 1, paddingLeft: c?.isFullWidth ? 0 : 16, paddingRight: c?.isFullWidth ? 0 : 16, width: c.width || '100%' }} />
                                        </div>
                                )
                                    : c.type === 'event' ?
                                        <div key={ci} className='px-[16px] w-full '>
                                            <div className='relative flex w-full my-[8px] flex-row justify-between p-[16px] rounded-[6px] items-center' style={{ borderWidth: 1, borderColor: 'white', gap: 4 }}>
                                                <div className='absolute bottom-0 left-0 right-0 top-0 rounded-[6px]' style={{ background: 'linear-gradient(180deg, #FFFFFF10 70%, #FFFFFF 100%)' }} />
                                                <img src={c?.image} className='w-[57px] rounded-[8px] z-[1]' style={{ objectFit: 'cover', height: undefined, aspectRatio: 1 }} />
                                                <div className='flex flex-col flex-1 z-[1]' style={{ gap: 4 }}>
                                                    <div className='text-[#473F3A] text-[18px] font-[600] w-full'>{c?.data || ""}</div>
                                                    <div className='text-[#979797] text-[12px] w-full'>{c?.subtitle || ""}</div>
                                                </div>
                                                <div>
                                                    <KnowMoreButton />
                                                </div>
                                            </div>
                                        </div>
                                        : <div key={ci} />
                        )}
                    </div>
                </div>


                <div className='w-full h-[250px]' />





            </div>
        </div>
    )
}



